import React, { FC } from 'react'
import SkeletonText from '../SkeletonText'
import './index.scss'

/** 子组件：经典模式左侧bar的skeleton */
const SidebarSkeleton: FC = () => {
  return (
    <div
      className='sidebar-skeleton'
    >
      <div>
        {
          new Array(1).fill(1).map((item, index) => {
            return (
              <SkeletonText key={index} animated style={{ width: '100%' }} />
            )
          })
        }
      </div>
    </div>
  )
}

export default SidebarSkeleton
